import type { ISwSettings } from "app/@types/ISwSettings";

export const isAppSolution = (swSettings: ISwSettings): boolean =>
    swSettings?.user?.customData?.quiz?.UserChosenSolution === "app-solution";

export const isTrialPlan = (swSettings: ISwSettings): boolean => swSettings?.components.Home.resources.IsTrial === true;

export const redirectToAppsSolution = (swSettings: ISwSettings): void => {
    window.location.href = swSettings.swsites.apps;
};
